// from general.js
/* global isMobileDevice */
// from JSP?
/* global teacherId teacherHasProfilePhoto teacherProfilePhotoURL toggleTeacherProfilePhotoUploadOverlay */

import { decorateFallbackForRetinaClassroomPhotoBG } from '../../classroomPhoto/fallbackForRetinaClassroomPhoto.js';


export function setupTeacherProfilePhotoForTeacherViewingTheirOwnPage(teacherPageInfo) {
    if (teacherPageInfo.classroomPhotoPendingScreening) {
        // TODO this is copypasta from projectpage/teacherProfilePhoto
        $('.js-classroom-photo-check')
            .removeClass('upload')
            .addClass('pending-screening')
            .html('<p><em>Your new classroom photo has been submitted for approval. Once a staff member approves it, it will be visible to all site visitors.</em></p>')
            .css({
                'background-image': 'url(' + baseCacheURL + 'images/classroom/fallback-classroom-300.png)',
            })
            .parent()
        // Slightly different from teacherProfilePhoto because the DOM layout's slightly different
            .css({ 'pointer-events': 'none' });
    }

    $.ajax({
        url: secureBaseURL + 'teacher/profile_photo_is_published.html?teacherId=' + teacherId,
        dataType: 'jsonp',
        success: function (data) {
            if (data.profilePhotoIsPublished) {
                addProfilePhotoEditSnippet('.js-teacher-photo-holder', data.profilePhotoURLs['68']);
            } else if (!isMobileDevice) {
                addProfilePhotoUploadSnippet('.js-teacher-photo-holder', data.profilePhotoURLs['68']);
            }
            $('.js-classroom-info-wrapper').css('padding-left', '2.25em');
        },
    });
}

export function setupTeacherProfilePhotoForNormalUser() {
    if (teacherHasProfilePhoto) {
        addProfilePhotoSnippet('.js-teacher-photo-holder', teacherProfilePhotoURL);
        $('.js-classroom-info-wrapper').css('padding-left', '2.25em');
    }
}

function addProfilePhotoSnippet(selector, photoURL) {
    const elem = '<span class="teacher-photo js-teacher-photo"></span>';
    $(selector).html(elem);
    $('.js-teacher-photo').css('background-image', 'url(' + photoURL + ')');
}

// [BGK, 2017-01-20] this method is very similar to a method of the same name in dc/projectpage/teacherProfilePhoto.js.
// perhaps there will be a future opportunity to combine the two methods and centralize them in a shared file.
function addProfilePhotoUploadSnippet(selector, photoURL) {
    let elem = '<a class="teacher-photo upload js-teacher-photo-change js-click-on-enter-or-space js-admin">';
    elem += '<span class="upload-tooltip">Add a profile photo to raise your chances of getting funded.</span>';
    elem += '<span tabindex=0 role="link" aria-label="Upload teacher profile photo" class="upload-photo js-click-on-enter-or-space"></span>';
    elem += '</a>';
    $(selector).html(elem);
    $('.js-teacher-photo-change').css('background-image', 'url("' + photoURL + '")');
    $('.js-teacher-photo-change').on('click', toggleTeacherProfilePhotoUploadOverlay);
}

function addProfilePhotoEditSnippet(selector, photoURL) {
    let html = '<span class="teacher-photo js-teacher-photo-change">';
    html += '<a tabindex=0 class="editable-link edit-teacher-photo js-click-on-enter-or-space js-admin js-edit-teacher-photo"><svg class="icon icon-picture"><use xlink:href="/images/icon/icon-junior.svg#icon-picture"></use></svg>Edit</a>';
    html += '</span>';
    $(selector).html(html);
    $('.js-teacher-photo-change').css('background-image', 'url("' + photoURL + '")');
    $('.js-edit-teacher-photo').on('click', toggleTeacherProfilePhotoUploadOverlay);
}

// JSONP callback from hideOverlayAndUpdateUnderlyingPageAfterTeacherProfilePhotoUploadCrop
window.onTeacherProfilePhotoUploadCropCompletion = function (data) {
    if ($('.js-teacher-photo-change').length > 0) {
        $('.js-teacher-photo-change').remove();
        addProfilePhotoEditSnippet('.js-teacher-photo-holder', secureS3URL + data.photoPaths['136']);
        if ($('.tpc-review.required').length > 0) {
            const uploadPhotoButton = $('.tpc-review.required');
            uploadPhotoButton.removeClass('required');
            const alertIcon = $('.classroom-photo-icon');
            alertIcon.remove();
        }
    }
};

$(window).on('userCookiesReset', function () {
    decorateFallbackForRetinaClassroomPhotoBG();
});
